import React from "react";
import { Route, Routes } from "react-router-dom";
import SalesDashboard from "./sales";
import SalesProducts from "./sales-products";
import RFMAnalysisDetail from "./rfm/RFMAnalysisDetail";
import RFMDashboard from "./rfm";
import CustomerSegmentsDashboard from "./customer-segments";
import LoyaltyReportsDashboard from "./loyalty";

const Reports = () => {
  return (
    <Routes>
      <Route path="sales" element={<SalesDashboard />} />
      <Route path="sales/products" element={<SalesProducts />} />
      <Route path="customer-segments" element={<CustomerSegmentsDashboard />} />
      <Route path="rfm" element={<RFMDashboard />} />
      <Route path="rfm/:analysisId" element={<RFMAnalysisDetail />} />
      <Route path="loyalty" element={<LoyaltyReportsDashboard />} />
    </Routes>
  );
};

export default Reports;
